<template>
  <a-modal
    :title="isAdd ? '新建教育局' : '修改教育局'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 教育局名字 -->
      <a-form-item
        label="教育局名字"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          v-decorator="[
            'bureauName',
            {
              rules: [
                { required: true, pattern: /^.{2,25}$/, message: '请输入长度为2~25位的教育局名字' },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>

      <!-- 教育局域名 -->
      <a-form-item
        label="教育局域名"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          style="width: 200px !important"
          v-decorator="[
            'domainName',
            {
              rules: [
                { required: true, pattern: /^[a-z\-]{2,40}$/, message: '请输入长度为2~40位字符' },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
        .khsdb.com
      </a-form-item>

      <!-- 站点名称 -->
      <a-form-item
        label="站点名称"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          v-decorator="['siteName', { rules: [{ required: true, message: '请输入' }] }]"
        />
      </a-form-item>

      <!-- 代理 -->
      <a-form-item label="代理" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select
          showSearch
          :allowClear="true"
          class="form-cell"
          placeholder="请选择"
          :filterOption="false"
          @search="searchAgency"
          :notFoundContent="searchLoading_agency ? undefined : '没有查询结果'"
          v-decorator="['agentId']"
        >
          <a-spin v-if="searchLoading_agency" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in agencyList" :key="d.id">{{ d.agentName }}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 负责人 -->
      <a-form-item
        label="负责人"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          mode="multiple"
          class="form-cell"
          placeholder="请选择"
          v-decorator="['managerId', { rules: [{ required: true, message: '请选择负责人' }] }]"
        >
          <a-select-option v-for="(item, index) in listManager" :key="index" :value="item.id">{{
            item.nickname
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 地区 -->
      <a-form-item
        label="地区"
        class="form-oper"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-cascader
          :options="$store.state.common.address"
          placeholder="请选择"
          changeOnSelect
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          v-decorator="['addressSelect', { rules: [{ required: true, message: '请选择地区' }] }]"
          :disabled="isAdd ? false : true"
        />
        <div class="explain">
          说明: 因为数据统计的关系，省市区仅在新建时确定，在新建以后不可修改
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import bureau from '../../api/bureau'

import person from '../../api/person'

import { analysisAddress } from '../../utils/address'
import agency from '../../api/agency'

export default {
  name: 'bureauFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      bureauId: '',
      updateData: {},
      listManager: [], //负责人列表
      agencyList: [], //代理人列表
      searchLoading_agency: false, //代理人loading
    }
  },
  methods: {
    //初始化，显示
    init(type, params) {
      this.visible = true
      this.isAdd = type === 'add' ? true : false

      //初始化form表单数据
      if (params) {
        console.log('params-----', params)
        this.updateData = params
        let formData = {}
        formData.bureauName = params.bureauName
        formData.managerId = params.managerIds
        formData.agentId = params.agentId
        formData.siteName = params.siteName
        formData.domainName = params.domainName ? params.domainName.split('.')[0] : ''
        formData.addressSelect = [params.provinceId, params.cityId, params.districtId]
        //修改入口，要记录当前教育局的ID
        this.bureauId = params.id
        //重置负责人列表（修改的之后，列表里面会多一条当前已绑定的负责人）
        this.getListManager(formData.managerId)
        this.searchAgency('', params.agentId)
        setTimeout(() => {
          this.form.setFieldsValue(formData)
        }, 100)
      } else {
        this.form.resetFields()
        this.getListManager()
        this.searchAgency()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        console.log('输入的内容是：', value)
        //校验通过
        if (!err) {
          //拼接域名
          value.domainName = value.domainName + '.khsdb.com'
          let tempValue = analysisAddress(value)
          if (!tempValue.cityId) {
            this.$message.error('请选择城市')
          } else {
            tempValue.managerIds = tempValue.managerId
            tempValue.managerId = tempValue.managerIds[0]
            if (this.isAdd) {
              this.addBureau(tempValue)
            } else {
              this.updateBureau(tempValue)
            }
          }
        }
      })
    },

    //新增教育局
    addBureau(value) {
      bureau.addBureau(value).then(res => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addBureau', res.data)
      })
    },

    //修改教育局
    updateBureau(value) {
      bureau.updateBureau(this.bureauId, value).then(res => {
        this.$message.success('修改成功')
        Object.assign(this.updateData, value)
        this.$emit('updateBureau', res.data)
        this.handleCancel()
      })
    },

    //查询负责人
    getListManager(managerId) {
      let req = {
        roleId: '2',
      }
      if (managerId instanceof Array && managerId.length > 0) {
        req.managerIds = managerId
      } else if (managerId) {
        req.managerId = managerId
      }
      person.getListManager(req).then(res => {
        this.listManager = res.data
      })
    },

    //代理列表
    searchAgency(val = '', id) {
      let req = {
        agentName: val,
        agentId: id,
      }
      agency.listAgentOfNoBinding(req).then(res => {
        this.agencyList = res.data
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.explain{
  margin-top: 8px;
  color: 	#8B8B7A;
  line-height: 25px;
  font-size: 15px;
}
</style>
